// extracted by mini-css-extract-plugin
export default {"video":"video_video__Il86+","play":"video_play__2Sjoc","stop":"video_stop__wcCS2"};